var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailingLists(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.42 31.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d,.e,.f{fill:none;}.g{fill:#ffaa50;}.e{stroke-width:1.32px;}.e,.f{stroke:#841a0c;stroke-linecap:round;stroke-linejoin:round;}.f{stroke-width:1.3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M15.71,29.71c7.73,0,14-6.27,14-14S23.44,1.71,15.71,1.71,1.71,7.98,1.71,15.71s6.27,14,14,14"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "7.98 13.62 5.77 13.62 5.77 27.14 25.66 27.14 25.66 13.62 23.45 13.62"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "f",
    points: "23.41 15.37 23.41 6.89 8.02 6.89 8.02 15.37"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "6.04 13.62 12.96 20.32 18.46 20.32 25.38 13.62"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 6.04,
    y1: 27.05,
    x2: 12.96,
    y2: 20.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 18.46,
    y1: 20.35,
    x2: 25.38,
    y2: 27.05
  })), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 10.57,
    y1: 9.9,
    x2: 20.86,
    y2: 9.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 10.57,
    y1: 12.57,
    x2: 20.86,
    y2: 12.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 10.57,
    y1: 15.23,
    x2: 20.86,
    y2: 15.23
  })), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 31.42,
    height: 31.42
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailingLists);
export default __webpack_public_path__ + "static/media/mailing_lists.edef831ed9e89942bc9a3676b36f2fc4.svg";
export { ForwardRef as ReactComponent };